import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { WarningAmber } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { FormControl, Grid, InputLabel, MenuItem, Select, Skeleton, TextField, } from '@mui/material';
import { FormValidation } from '../../../core/utility';
import { CommonService, LocalService, PublicService } from '../../../core/services';
import { ImageCrop } from '../../../components';
import { UserLogin } from '../../../redux/action';
import './company-trade-details.scss';
import FileUploadPopup from '../../../components/popup/file-upload-popup';
import { Button } from 'react-bootstrap';
import { MenuPropsSelect } from '../../../core/utility/style';
import * as gtUtil from "../../../core/utility";
import { GSTIN_TOKEN } from '../../../config/config';

const publicService = new PublicService();
const formValidation = new FormValidation();
const commonService = new CommonService();
const localService = new LocalService();

interface Props {
    UserReducer: any;
    updateAccountImage: (data: any) => void;
}

interface FieldError {
  status: boolean; // true means valid, false means invalid
  message: string;
}



const CommonCompanyDetails: React.FC<Props> = (props: Props) => {
    const [showUploadPopup, setShowUploadPopup] = useState<any>(false);
    const [disableInput, setDisableInput] = useState(props.UserReducer.gstin ? true : false);
    const [loading, setLoading] = useState(false);
    const [formErrors, setFormErrors] = useState({
        company_trade_name: { status: true, message: '' },
        company_type: { status: true, message: '' },
        address: { status: true, message: '' },
        pincode: { status: true, message: '' },
        state: { status: true, message: '' },
        country: { status: true, message: '' },
        pan: { status: true, message: '' },
        aadhaar: { status: true, message: '' },
        gstin: { status: true, message: '' },
        });

    const [path, setPath] = useState({ type: '', path: '' });
    const [pincode, setPincode] = useState('');
    const [GSTIN, setGSTIN] = useState('');
    const [accountForm, setAccountForm] = useState({
        account_id: props.UserReducer.account_id,
        company_trade_name: '',
        gstin: '',
        company_type: '',
        address: '',
        pincode: '',
        state: '',
        country: '',
        pan: '',
        aadhaar: '',
        logo: '',
        signature: ''
    });


    // useEffect(() => {
    //     const { logo, signature } = accountForm;

    //     if (logo && logo !== props.UserReducer.logo) {
    //         props.updateAccountImage({ ...props.UserReducer, ...accountForm });
    //     }

    //     if (signature && signature !== props.UserReducer.signature) {
    //         props.updateAccountImage({ ...props.UserReducer, ...accountForm });
    //     }
    // }, [accountForm]);
    async function getCompanyTradeDetails() {
            setLoading(true)
            try {
                const response = await commonService.getCompanyTradeDetails(props.UserReducer.account_id);
                if (response.status === gtUtil.Constants.SUCCESS) {
                    setAccountForm({ ...accountForm, ...response.data.rows[0] });
                    setPincode(response.data.rows[0].pincode);
                    setGSTIN(response.data.rows[0].gstin);
                    setDisableInput(response.data.rows[0].gstin != '');
                    setFormErrors({
                        company_trade_name: { status: true, message: '' },
                        company_type: { status: true, message: '' },
                        address: { status: true, message: '' },
                        pincode: { status: true, message: '' },
                        state: { status: true, message: '' },
                        country: { status: true, message: '' },
                        pan: { status: true, message: '' },
                        aadhaar: { status: true, message: '' },
                        gstin: { status: true, message: '' },
                        });
                }
                setLoading(false)
            } catch (error) {
                console.log('Get Notification Error', JSON.stringify(error));
                setLoading(false)
            }
    };

    useEffect(() => {
        getCompanyTradeDetails();
    }, [])


    function accountFormValidation(key: string, value: any) {
        if(key === 'gstin') {
            setGSTIN(value);
        }else{
            setAccountForm((prevData) => ({ ...prevData, [key]: value }));
        }

        let error: FieldError = { status: true, message: '' };

        switch (key) {
            case 'company_trade_name':
            case 'company_type':
            case 'address':
            error = formValidation.GetNameValidate(value);
            break;
            case 'pan':
            if(value && value.trim() !== '') {
                error = formValidation.getPANisValid(value);
            }
            break;
            case 'aadhaar':
            if(value && value.trim() !== '' && accountForm.aadhaar !== '0') {
                error = formValidation.getAadhaarisValid(value);
            }
            break
            case 'gstin':
            if(value && value.trim() !== '') {
                error = formValidation.getgstIsValid(value);
            }
            break;
            case 'pincode':
            error = formValidation.GetPincodeValid(value);
            break;
            default:
            error = { status: true, message: '' };
        }

        setFormErrors((prev:any) => ({ ...prev, [key]: error }));
    }



    async function handleVerify() {
        setLoading(true);
        try {
            let response = await publicService.getGSTINDetail(
                {
                    gstin: GSTIN,
                    gstinOptionalToken: GSTIN_TOKEN
                }
            );
            if (response.data.flag) {
                const gstinData = response.data.data;
                setPincode(gstinData.pradr.addr.pncd.substring(0, gstinData.pradr.addr.pncd.length));
                setAccountForm((r) => {
                    r.gstin = GSTIN;
                    r.company_trade_name = gstinData.tradeNam;
                    r.company_type = gstinData.ctb;
                    r.address = gstinData.pradr.adr;
                    r.pincode = gstinData.pradr.addr.pncd.substring(0, gstinData.pradr.addr.pncd.length);
                    r.pan = gstinData.gstin.substring(2, gstinData.gstin.length - 3)
                    r.state = gstinData.pradr.addr.stcd
                    return { ...r }
                });

                setDisableInput(true);
            }
        } catch (error) {
            throw new Error(`handleVerifySave error :: ${error}`)
        } finally {
            setLoading(false);
        }
    }

    async function handlePincode(pincode: any) {
        try {
            setLoading(true);
            setPincode(pincode);
            if(pincode.length == 6) {
                let response = await publicService.getPincodeDetails(
                    {
                        pincode : pincode,
                        gstinOptionalToken: GSTIN_TOKEN
                    }
                );
                if(response.status === gtUtil.Constants.SUCCESS){
                    setAccountForm(prev => ({
                    ...prev,
                    state: response.data.State,
                    country: response.data.Country,
                    pincode: pincode
                    }));
                    setFormErrors((prev:any) => ({ ...prev, pincode: { status: true, message: '' } }));
                }
            }
        } catch (error) {
        //    console.log('handlePincode error ==> ', JSON.stringify(error))
        } finally {
           setLoading(false);
        }
    }

    // async function saveAccountDetail() {
    //     setLoading(true);
    //     try {
    //         const {
    //         company_trade_name,
    //         address,
    //         pincode,
    //         state,
    //         country
    //         } = accountForm;

    //         let errors: any = {};

    //         if (!company_trade_name || company_trade_name.trim() === '') {
    //         errors.company_trade_name = { status: false, message: 'Company Trade Name is required' };
    //         }

    //         if (!address || address.trim() === '') {
    //         errors.address = { status: false, message: 'Address is required' };
    //         }

    //         if (!pincode || !/^\d{6}$/.test(pincode)) {
    //         errors.pincode = { status: false, message: 'Pincode must be 6 digits' };
    //         }

    //         if (!state || state.trim() === '') {
    //         errors.state = { status: false, message: 'State is required' };
    //         }

    //         if (!country || country.trim() === '') {
    //         errors.country = { status: false, message: 'Country is required' };
    //         }

    //         setFormErrors((prev: any) => ({ ...prev, ...errors }));

    //         // If there are any invalid fields, stop submission
    //         const hasErrors = Object.values(errors).some((err: any) => err.status === false);
    //         if (hasErrors) {
    //         console.log('Validation errors:', errors);
    //         setLoading(false);
    //         return;
    //         }

    //         // Submit form
    //         const response: any = await commonService.updateAccountDetail(accountForm);
    //         const status: string = response.status === gtUtil.Constants.SUCCESS ? 'success' : 'error';
    //         localService.toastify(response.info, status, 1000);

    //     } catch (error) {
    //         console.log('saveAccountDetail error ==> ', JSON.stringify(error));
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    async function saveAccountDetail() {
        setLoading(true);

        try {
            const {
            company_trade_name,
            company_type,
            address,
            pincode,
            state,
            country,
            pan,
            aadhaar,
            gstin
            } = accountForm;

            const errors: Record<string, FieldError> = {
            company_trade_name: formValidation.GetNameValidate(company_trade_name),
            // company_type: formValidation.GetNameValidate(company_type),
            address: formValidation.GetNameValidate(address),
            pincode: formValidation.GetPincodeValid(pincode),
            state: state?.trim()
                ? { status: true, message: '' }
                : { status: false, message: 'State is required' },
            country: country?.trim()
                ? { status: true, message: '' }
                : { status: false, message: 'Country is required' },
            pan: pan && pan !== '0' ? formValidation.getPANisValid(pan) : { status: true, message: '' },
            aadhaar: aadhaar && aadhaar !== '0'
                ? formValidation.getAadhaarisValid(aadhaar)
                : { status: true, message: '' },
            };

            //Set all errors in state
            setFormErrors((prev) => ({ ...prev, ...errors }));

            //Check if any field invalid
            const hasErrors = Object.values(errors).some((err) => err.status === false);
            if (hasErrors) {
            setLoading(false);
            return;
            }

            const response: any = await commonService.updateAccountDetail(accountForm);
            if (response.status === gtUtil.Constants.SUCCESS) {
                getCompanyTradeDetails();
            }
            const status: string =
            response.status === gtUtil.Constants.SUCCESS ? 'success' : 'error';
            localService.toastify(response.info, status, 1000);
        } catch (error) {
            // console.log('saveAccountDetail error ==> ', JSON.stringify(error));
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className='company-trade-detail'>
                {/* {showUploadPopup && (
                    <ImageCrop
                        ratio={1 / 1}
                        path={path.path}
                        popup={(e) => setShowUploadPopup(e)}
                        onCroped={(e) => {
                            setAccountForm((prevData: any) => {
                                prevData[`${path.type}`] = e.url;
                                prevData[`${path.type}_path`] = e.key;
                                return { ...prevData };
                            })
                        }}
                    />
                )} */}
                {showUploadPopup && (
                    <FileUploadPopup openModal={showUploadPopup} onClose={(e) => setShowUploadPopup(false)} onSend={(e: any) =>
                        setAccountForm((prevData: any) => {
                            prevData[`${path.type}`] = e.url;
                            prevData[`${path.type}_path`] = e.key;
                            return { ...prevData };
                        })
                    }
                        path={path.path}
                        acceptedFileTypes=".jpg, .jpeg, .png"
                        fileMaximumSize={path.type === 'logo' ? 800 : 100}
                    />
                )}
                <div className='list-section-content rounded'>
                    <div className='row'>
                        <strong className='d-block'>
                            Company Details
                        </strong>
                    </div>
                </div>
                <div className='row'>
                    <strong className='d-md-block d-none'>
                        Verify Details
                    </strong>
                </div>
                <div className='row'>
                    <div className='col'>
                        <div className='row mt-3'>
                            <div className='col'>
                                {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                                    className='w-100 col input-common'
                                    size='small'
                                    type='text'
                                    name='gstin'
                                    id='id_gstin'
                                    label='GSTIN'
                                    error={!formErrors?.gstin?.status}
                                    helperText={formErrors?.gstin?.message}
                                    value={GSTIN}
                                    onChange={(e) => accountFormValidation('gstin', e.target.value)}
                                />
                                }
                            </div>
                            <div className='col-auto ps-0 col-md'>
                                <LoadingButton
                                    className='btn btn-outline-primary col-auto'
                                    loading={loading}
                                    loadingPosition='start'
                                    variant='contained'
                                    onClick={handleVerify}
                                >
                                    Verify
                                </LoadingButton>
                            </div>
                        </div>
                    </div>
                </div>
                                
                <Grid container spacing={3} className='company-trade-form'>
                    <Grid item xs={12} className='d-none d-md-flex'>
                        <hr className='w-100 mb-0 d-none d-md-flex' />
                    </Grid>
                    <Grid item xs={12} >
                        <strong className='d-md-block d-none'>
                            Details
                        </strong>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                            disabled={disableInput}
                            className='w-100 input-common'
                            required
                            name='company_trade_name'
                            size='small'
                            fullWidth
                            label='Company/Trade Name'
                            id='fullWidth'
                            value={accountForm.company_trade_name}
                            error={!formErrors?.company_trade_name?.status}
                            helperText={formErrors?.company_trade_name?.message}
                            onChange={(e) => accountFormValidation('company_trade_name', e.target.value)}
                        />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : 
                            <> 
                                {!disableInput &&
                                    <FormControl fullWidth size='small'>
                                        <InputLabel id='demo-multiple-name-label'>
                                            Company/Trade type
                                        </InputLabel>
                                        <Select
                                            disabled={disableInput}
                                            className='w-100 input-common'
                                            required
                                            labelId='demo-multiple-name-label'
                                            id='demo-multiple-name'
                                            name='company_type'
                                            label='Company/Trade Type'
                                            defaultValue={accountForm.company_type}
                                            value={accountForm.company_type}
                                            onChange={(e) => accountFormValidation('company_type', e.target.value)}
                                            MenuProps={MenuPropsSelect}
                                        >
                                            <MenuItem value={'Individual'}>
                                                Individual
                                            </MenuItem>
                                            <MenuItem value={'Parternship'}>
                                                Parternship
                                            </MenuItem>
                                            <MenuItem
                                                value={
                                                    'Limited Liability Parternship'
                                                }
                                            >
                                                Limited Liability Parternship
                                            </MenuItem>
                                            <MenuItem
                                                value={'Private Limited Company'}
                                            >
                                                Private Limited Company
                                            </MenuItem>
                                            <MenuItem
                                                value={'Public Limited Company'}
                                            >
                                                Public Limited Company
                                            </MenuItem>
                                            <MenuItem value={'One Person Company'}>
                                                One Person Company
                                            </MenuItem>
                                            <MenuItem value={'Sole reprietorship'}>
                                                Sole reprietorship
                                            </MenuItem>
                                            <MenuItem
                                                value={
                                                    'Non-Government Organization '
                                                }
                                            >
                                                Non-Government Organization (NGO)
                                            </MenuItem>
                                            <MenuItem
                                                value={'Joint-Venture Company'}
                                            >
                                                Joint-Venture Company
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                }

                                {disableInput && 
                                    <TextField
                                        disabled={disableInput}
                                        className='w-100 input-common'
                                        name='company_type'
                                        size='small'
                                        fullWidth
                                        label='Company/Trade Type'
                                        id='fullWidth'
                                        value={accountForm.company_type}
                                        // error={!formErrors?.company_type?.status}
                                        // helperText={formErrors?.company_type?.message}
                                        onChange={(e) => accountFormValidation('company_type', e.target.value)}
                                    />
                                }
                            </>
                        }
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                            required
                            className='w-100 input-common'
                            size='small'
                            name='Address'
                            id='outlined-multiline-flexible'
                            label='Address'
                            multiline
                            maxRows={2}
                            value={accountForm.address}
                            disabled={disableInput}
                            error={!formErrors?.address?.status}
                            helperText={formErrors?.address?.message}
                            onChange={(e) => accountFormValidation('address', e.target.value)}
                        />}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                            required
                            className='w-100 contact_number input-common'
                            size='small'
                            type='number'
                            name='Pin_Code'
                            label='Pin Code'
                            value={pincode}
                            disabled={disableInput}
                            error={!formErrors?.pincode?.status}
                            helperText={formErrors?.pincode?.message}
                            onChange={(e) => handlePincode(e.target.value)}
                        />}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                            required
                            className='w-100 input-common'
                            size='small'
                            type='text'
                            name='Country'
                            disabled
                            label='Country'
                            value={accountForm.country}
                        />}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                            required
                            className='w-100 input-common'
                            size='small'
                            type='text'
                            name='State'
                            disabled
                            label='State'
                            value={accountForm.state}
                        />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                            disabled={disableInput}
                            className='w-100 input-common'
                            size='small'
                            type='text'
                            name='PAN'
                            label='PAN'
                            error={!formErrors?.pan?.status}
                            helperText={formErrors?.pan?.message}
                            value={accountForm.pan}
                            onChange={(e) => accountFormValidation('pan', e.target.value)}
                        />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {loading ? <Skeleton variant="rounded" height={40} /> : <TextField
                            className='w-100 input-common'
                            size='small'
                            type='text'
                            name='Aadhaar'
                            label='Aadhaar'
                            error={!formErrors?.aadhaar?.status}
                            helperText={formErrors?.aadhaar?.message}
                            value={accountForm.aadhaar}
                            onChange={(e) => accountFormValidation('aadhaar', e.target.value)}
                        />}
                    </Grid>
                    <Grid item xs={12} md={6} className='d-flex upload-sec flex-column flex-md-row'>
                        <h6>Company/trade logo</h6>

                        {accountForm.logo &&
                            (
                                <div className='mt-1'>
                                {loading ? <Skeleton variant="rounded" height={100} width={150} /> : <img src={accountForm.logo} alt='logo' style={{ height: '100px' }} />}
                                </div>
                            )
                        }

                        {/* <span className='img-upload-sec mt-3'>
                            <span
                                onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'logo', path: `accounts/${props.UserReducer.account_id}/logo` }) }}
                                className='img-upload'
                            ></span>{' '}
                            <WarningAmber />
                            <span className='fs-12'>
                                (jpeg. upto 100kb)
                            </span>

                        </span> */}
                        <Button
                            className='btn btn-outline-primary mt-3 upload_button d-none d-md-flex'
                            onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'logo', path: `accounts/${props.UserReducer.account_id}/logo` }) }}
                            variant='contained'
                        >
                            Upload Image
                        </Button>
                        <Button
                            className='btn btn-text-link ms-auto upload_button d-md-none'
                            onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'logo', path: `accounts/${props.UserReducer.account_id}/logo` }) }}
                            variant='contained'
                        >
                            Upload
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6} className='d-flex upload-sec flex-column flex-md-row'>
                        <h6 className=''>Signature</h6>
                        {accountForm.signature &&
                            (
                                <div className='mt-1'>
                                {loading ? <Skeleton variant="rounded" height={100} width={150} /> : <img src={accountForm.signature} alt='logo' style={{ height: '100px' }} />}
                                </div>
                            )
                        }

                        {/* <span className='img-upload-sec mt-3'>
                            <span
                                onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'signature', path: `accounts/${props.UserReducer.account_id}/signature` }) }}
                                className='img-upload'
                            ></span>{' '}
                            <WarningAmber />
                            <span className='fs-12'>
                                (jpeg. upto 100kb)
                            </span>
                        </span> */}
                        
                        <Button
                            className='btn btn-outline-primary mt-3 upload_button d-none d-md-flex'
                            onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'signature', path: `accounts/${props.UserReducer.account_id}/signature` }) }}
                            variant='contained'
                        >
                            Upload Image
                        </Button>
                        <Button
                            className='btn btn-text-link ms-auto upload_button d-md-none'
                            onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'signature', path: `accounts/${props.UserReducer.account_id}/signature` }) }}
                            variant='contained'
                        >
                            Upload
                        </Button>
                    </Grid>
                    <Grid item xs={12} className='company-trade-detail-save-btn btn-fixed-bottom'>
                        <div className=' showupload mt-md-5'>
                            <LoadingButton
                                className='btn btn-primary'
                                loading={loading}
                                loadingPosition='start'
                                variant='contained'
                                onClick={saveAccountDetail}
                                disabled={loading}
                            >
                                Save
                            </LoadingButton>
                        </div>
                    </Grid>
                </Grid>
                <div className='row mt-3 d-none d-md-flex'>
                    <hr />

                    <div className='col'>
                        {/* <div className='row mt-3'>
                            <div className='col-12 col-md-6'>
                                <TextField
                                    disabled={disableInput}
                                    className='w-100 input-common'
                                    required
                                    name='company_trade_name'
                                    size='small'
                                    fullWidth
                                    label='Company/Trade Name'
                                    id='fullWidth'
                                    value={accountForm.company_trade_name}
                                    error={!formErrors?.company_trade_name?.status}
                                    helperText={formErrors?.company_trade_name?.message}
                                    onChange={(e) => accountFormValidation('company_trade_name', e.target.value)}
                                />
                            </div>
                            <div className='col'>
                                <FormControl fullWidth size='small'>
                                    <InputLabel id='demo-multiple-name-label'>
                                        Company/Trade type
                                    </InputLabel>
                                    <Select
                                        disabled={disableInput}
                                        className='w-100 input-common'
                                        required
                                        labelId='demo-multiple-name-label'
                                        id='demo-multiple-name'
                                        name='company_type'
                                        label='Company/Trade Type'
                                        defaultValue={accountForm.company_type}
                                        value={accountForm.company_type}
                                        onChange={(e) => accountFormValidation('company_type', e.target.value)}
                                    >
                                        <MenuItem value={'Individual'}>
                                            Individual
                                        </MenuItem>
                                        <MenuItem value={'Parternship'}>
                                            Parternship
                                        </MenuItem>
                                        <MenuItem
                                            value={
                                                'Limited Liability Parternship'
                                            }
                                        >
                                            Limited Liability Parternship
                                        </MenuItem>
                                        <MenuItem
                                            value={'Private Limited Company'}
                                        >
                                            Private Limited Company
                                        </MenuItem>
                                        <MenuItem
                                            value={'Public Limited Company'}
                                        >
                                            Public Limited Company
                                        </MenuItem>
                                        <MenuItem value={'One Person Company'}>
                                            One Person Company
                                        </MenuItem>
                                        <MenuItem value={'Sole reprietorship'}>
                                            Sole reprietorship
                                        </MenuItem>
                                        <MenuItem
                                            value={
                                                'Non-Government Organization '
                                            }
                                        >
                                            Non-Government Organization (NGO)
                                        </MenuItem>
                                        <MenuItem
                                            value={'Joint-Venture Company'}
                                        >
                                            Joint-Venture Company
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col'>
                                <TextField
                                    required
                                    className='w-100 input-common'
                                    size='small'
                                    name='Address'
                                    id='outlined-multiline-flexible'
                                    label='Address'
                                    multiline
                                    maxRows={2}
                                    value={accountForm.address}
                                    disabled={disableInput}
                                    error={formErrors?.address?.status}
                                    helperText={formErrors?.address?.message}
                                    onChange={(e) => accountFormValidation('address', e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col'>
                                <TextField
                                    required
                                    className='w-100 contact_number input-common'
                                    size='small'
                                    type='number'
                                    name='Pin_Code'
                                    label='Pin Code'
                                    value={accountForm.pincode}
                                    disabled={disableInput}
                                    error={formErrors?.pincode?.status}
                                    helperText={formErrors?.pincode?.message}
                                    onChange={(e) => accountFormValidation('pincode', e.target.value)}
                                />
                            </div>
                            <div className='col'>
                                <TextField
                                    required
                                    className='w-100 input-common'
                                    size='small'
                                    type='text'
                                    name='Country'
                                    disabled
                                    label='Country'
                                    value={accountForm.country}
                                />
                            </div>
                            <div className='col'>
                                <TextField
                                    required
                                    className='w-100 input-common'
                                    size='small'
                                    type='text'
                                    name='State'
                                    disabled
                                    label='State'
                                    value={accountForm.state}
                                />
                            </div>
                        </div>
                        <div className='row mt-3'>

                            <div className='col'>
                                <TextField
                                    disabled={disableInput}
                                    className='w-100 input-common'
                                    size='small'
                                    type='text'
                                    name='PAN'
                                    label='PAN'
                                    value={accountForm.pan}
                                    onChange={(e) => accountFormValidation('pan', e.target.value)}
                                />
                            </div>
                            <div className='col'>
                                <TextField
                                    className='w-100 input-common'
                                    size='small'
                                    type='text'
                                    name='Aadhaar'
                                    label='Aadhaar'
                                    value={accountForm.aadhaar}
                                    onChange={(e) => accountFormValidation('aadhaar', e.target.value)}
                                />
                            </div>
                        </div> */}

                        {/* <div className='row mt-3'>
                            <div className='col'>
                                <h6>Company/trade logo</h6>
                                {accountForm.logo &&
                                    (
                                        <img src={accountForm.logo} alt='logo' style={{ height: '100px' }} />
                                    )
                                }

                                <span className='img-upload-sec mt-3'>
                                    <span
                                        onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'logo', path: `accounts/${props.UserReducer.account_id}/logo` }) }}
                                        className='img-upload'
                                    ></span>{' '}
                                    <WarningAmber />
                                    <span className='fs-12'>
                                        (jpeg. upto 100kb)
                                    </span>
                                </span>
                            </div>
                            <div className='col'>
                                <h6>Signature</h6>
                                {accountForm.signature &&
                                    (
                                        <img src={accountForm.signature} alt='logo' style={{ height: '100px' }} />
                                    )
                                }

                                <span className='img-upload-sec mt-3'>
                                    <span
                                        onClick={() => { setShowUploadPopup(!showUploadPopup); setPath({ ...path, type: 'signature', path: `accounts/${props.UserReducer.account_id}/signature` }) }}
                                        className='img-upload'
                                    ></span>{' '}
                                    <WarningAmber />
                                    <span className='fs-12'>
                                        (jpeg. upto 100kb)
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col showupload mt-5'>
                                <LoadingButton
                                    className='btn btn-primary'
                                    loading={loading}
                                    loadingPosition='start'
                                    variant='contained'
                                    onClick={saveAccountDetail}
                                >
                                    Save
                                </LoadingButton>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
};


const mapStateToProps = (state: any) => {
    return {
        UserReducer: state.UserReducer.UserData,
        campaignReducer: state.CreateCampaignReducer,
        UserID: state.UserID.userID
    }
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        updateAccountImage: (data: any) => dispatch(UserLogin(data))
    }
}



const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(CommonCompanyDetails);

export { connectToRedux as CommonCompanyDetails };